module.exports = __webpack_public_path__ + "static/Download_on_the_App_Store_Badge_FR_RGB_blk_100517-0b499038cb1c7f62028075a71cf88fe3.png";